module.exports = __webpack_public_path__ + "static/media/liftago.d49eb5c9.jpg";